import { str, bool, date, FieldMap } from '../acordFieldEngine';

export const ACORD28_POLICY_MAP: FieldMap = {
  policyNumber:   str('Policy_PolicyNumberIdentifier_A'),
  effectiveDate:  date('Policy_EffectiveDate_A'),
  expirationDate: date('Policy_ExpirationDate_A'),
};

export const ACORD28_MAP: FieldMap = {

  perilsInsured:        bool('Policy_PolicyType_PerilsInsuredIndicator_A'),
  perilsBasic:          bool('Policy_PolicyType_BasicIndicator_A'),
  perilsBroad:          bool('Policy_PolicyType_BroadIndicator_A'),
  perilsSpecial:        bool('Policy_PolicyType_SpecialIndicator_A'),
  perilsOther:          bool('Policy_PolicyType_OtherIndicator_A'),
  perilsOtherDesc:      str('Policy_PolicyType_OtherDescription_A'),

  commPropAmount:       str('CommercialPropertyCoverage_Property_LimitAmount_A'),
  commPropDed:          str('CommercialPropertyCoverage_Property_DeductibleAmount_A'),

  businessIncome:       bool('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_BusinessIncomeCoverageIndicator_A'),
  rentalValue:          bool('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_RentalValueCoverageIndicator_A'),
  birvYes:              bool('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_YesIndicator_A'),
  birvNo:               bool('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_NoIndicator_A'),
  birvNa:               bool('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_NotApplicableIndicator_A'),
  birvLimit:            str('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_LimitAmount_A'),
  birvActualLoss:       bool('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_ActualLossSustainedIndicator_A'),
  birvMonths:           str('CommercialPropertyCoverage_BusinessIncomeOrRentalValue_ActualLossSustainedMonthCount_A'),

  blanketYes:           bool('CommercialProperty_Blanket_YesIndicator_A'),
  blanketNo:            bool('CommercialProperty_Blanket_NoIndicator_A'),
  blanketNa:            bool('CommercialProperty_Blanket_NotApplicableIndicator_A'),
  blanketAmount:        str('StatementOfValues_Premises_ValueAmount_A'),

  terrorismYes:         bool('CommercialPropertyCoverage_Terrorism_YesIndicator_A'),
  terrorismNo:          bool('CommercialPropertyCoverage_Terrorism_NoIndicator_A'),
  terrorismNa:          bool('CommercialPropertyCoverage_Terrorism_NotApplicableIndicator_A'),
  terrorismExclYes:     bool('CommercialPropertyCoverage_TerrorismExclusion_YesIndicator_A'),
  terrorismExclNo:      bool('CommercialPropertyCoverage_TerrorismExclusion_NoIndicator_A'),
  terrorismExclNa:      bool('CommercialPropertyCoverage_TerrorismExclusion_NotApplicableIndicator_A'),
  domesticTerrYes:      bool('CommercialPropertyCoverage_DomesticTerrorismExclusion_YesIndicator_A'),
  domesticTerrNo:       bool('CommercialPropertyCoverage_DomesticTerrorismExclusion_NoIndicator_A'),
  domesticTerrNa:       bool('CommercialPropertyCoverage_DomesticTerrorismExclusion_NotApplicableIndicator_A'),

  limitedFungusYes:     bool('CommercialPropertyCoverage_LimitedFungus_YesIndicator_A'),
  limitedFungusNo:      bool('CommercialPropertyCoverage_LimitedFungus_NoIndicator_A'),
  limitedFungusNa:      bool('CommercialPropertyCoverage_LimitedFungus_NotApplicableIndicator_A'),
  limitedFungusLimit:   str('CommercialPropertyCoverage_LimitedFungus_LimitAmount_A'),
  limitedFungusDed:     str('CommercialPropertyCoverage_LimitedFungus_DeductibleAmount_A'),

  fungusExclYes:        bool('CommercialPropertyCoverage_FungusExclusion_YesIndicator_A'),
  fungusExclNo:         bool('CommercialPropertyCoverage_FungusExclusion_NoIndicator_A'),
  fungusExclNa:         bool('CommercialPropertyCoverage_FungusExclusion_NotApplicableIndicator_A'),
  fungusExclForm:       str('FormEndorsement_FormIdentifier_A'),
  fungusExclDate:       str('FormEndorsement_FormDate_A'),
  fungusExclText:       str('FormEndorsement_CopyrightOwnerCode_A'),

  replacementCostYes:   bool('CommercialPropertyCoverage_ReplacementCost_YesIndicator_A'),
  replacementCostNo:    bool('CommercialPropertyCoverage_ReplacementCost_NoIndicator_A'),
  replacementCostNa:    bool('CommercialPropertyCoverage_ReplacementCost_NotApplicableIndicator_A'),

  agreedValueYes:       bool('CommercialPropertyCoverage_AgreedValue_YesIndicator_A'),
  agreedValueNo:        bool('CommercialPropertyCoverage_AgreedValue_NoIndicator_A'),
  agreedValueNa:        bool('CommercialPropertyCoverage_AgreedValue_NotApplicableIndicator_A'),

  coinsuranceYes:       bool('CommercialPropertyCoverage_Coinsurance_YesIndicator_A'),
  coinsuranceNo:        bool('CommercialPropertyCoverage_Coinsurance_NoIndicator_A'),
  coinsuranceNa:        bool('CommercialPropertyCoverage_Coinsurance_NotApplicableIndicator_A'),
  coinsurancePercent:   str('CommercialProperty_Premises_CoinsurancePercent_A'),

  equipmentYes:         bool('CommercialPropertyCoverage_EquipmentBreakdown_YesIndicator_A'),
  equipmentNo:          bool('CommercialPropertyCoverage_EquipmentBreakdown_NoIndicator_A'),
  equipmentNa:          bool('CommercialPropertyCoverage_EquipmentBreakdown_NotApplicableIndicator_A'),
  equipmentLimit:       str('CommercialPropertyCoverage_EquipmentBreakdown_LimitAmount_A'),
  equipmentDed:         str('CommercialPropertyCoverage_EquipmentBreakdown_DeductibleAmount_A'),

  ordinanceYes:         bool('CommercialProperty_BuildingOrdinanceOrLaw_UndamagedPortionOfBuildingYesIndicator_A'),
  ordinanceNo:          bool('CommercialProperty_BuildingOrdinanceOrLaw_UndamagedPortionOfBuildingNoIndicator_A'),
  ordinanceNa:          bool('CommercialProperty_BuildingOrdinanceOrLaw_UndamagedPortionOfBuildingNotApplicableIndicator_A'),
  ordinanceLimit:       str('CommercialPropertyCoverage_BuildingOrdinanceOrLaw_UndamagedPortionBuildingLimitAmount_A'),
  ordinanceDed:         str('CommercialPropertyCoverage_BuildingOrdinanceOrLaw_UndamagedPortionBuildingDeductibleAmount_A'),

  demolitionYes:        bool('CommercialProperty_BuildingOrdinanceOrLaw_DemolitionCostsYesIndicator_A'),
  demolitionNo:         bool('CommercialProperty_BuildingOrdinanceOrLaw_DemolitionCostsNoIndicator_A'),
  demolitionNa:         bool('CommercialProperty_BuildingOrdinanceOrLaw_DemolitionCostsNotApplicableIndicator_A'),
  demolitionLimit:      str('CommercialProperty_BuildingOrdinanceOrLaw_DemolitionCostsLimitAmount_A'),
  demolitionDed:        str('CommercialProperty_BuildingOrdinanceOrLaw_DemolitionCostsDeductibleAmount_A'),

  incrCostYes:          bool('CommercialProperty_BuildingOrdinanceOrLaw_IncreasedCostOfConstructionYesIndicator_A'),
  incrCostNo:           bool('CommercialProperty_BuildingOrdinanceOrLaw_IncreasedCostOfConstructionNoIndicator_A'),
  incrCostNa:           bool('CommercialProperty_BuildingOrdinanceOrLaw_IncreasedCostOfConstructionNotApplicableIndicator_A'),
  incrCostLimit:        str('CommercialProperty_BuildingOrdinanceOrLaw_IncreasedCostOfConstructionLimitAmount_A'),
  incrCostDed:          str('CommercialProperty_BuildingOrdinanceOrLaw_IncreasedCostOfConstructionDeductibleAmount_A'),

  earthYes:             bool('CommercialPropertyCoverage_EarthMovement_YesIndicator_A'),
  earthNo:              bool('CommercialPropertyCoverage_EarthMovement_NoIndicator_A'),
  earthNa:              bool('CommercialPropertyCoverage_EarthMovement_NotApplicableIndicator_A'),
  earthLimit:           str('CommercialPropertyCoverage_EarthMovement_LimitAmount_A'),
  earthDed:             str('CommercialPropertyCoverage_EarthMovement_DeductibleAmount_A'),

  floodYes:             bool('CommercialPropertyCoverage_Flood_YesIndicator_A'),
  floodNo:              bool('CommercialPropertyCoverage_Flood_NoIndicator_A'),
  floodNa:              bool('CommercialPropertyCoverage_Flood_NotApplicableIndicator_A'),
  floodLimit:           str('CommercialPropertyCoverage_Flood_LimitAmount_A'),
  floodDed:             str('CommercialPropertyCoverage_Flood_DeductibleAmount_A'),

  windHailInclYes:      bool('CommercialPropertyCoverage_WindHail_YesIndicator_A'),
  windHailInclNo:       bool('CommercialPropertyCoverage_WindHail_NoIndicator_A'),
  windHailSubjYes:      bool('CommercialPropertyCoverage_WindHail_SubjectToProvisionsIndicator_A'),
  windHailSubjNo:       bool('CommercialPropertyCoverage_WindHail_SubjectToProvisionsNoIndicator_A'),
  windHailNa:           bool('CommercialPropertyCoverage_WindHail_NotApplicableIndicator_A'),
  windHailLimit:        str('CommercialPropertyCoverage_WindHail_LimitAmount_A'),
  windHailDed:          str('CommercialPropertyCoverage_WindHail_DeductibleAmount_A'),

  namedStormInclYes:    bool('CommercialPropertyCoverage_NamedWindstorm_YesIndicator_A'),
  namedStormInclNo:     bool('CommercialPropertyCoverage_NamedWindstorm_NoIndicator_A'),
  namedStormSubjYes:    bool('CommercialPropertyCoverage_NamedWindstorm_SubjectToProvisionsIndicator_A'),
  namedStormSubjNo:     bool('CommercialPropertyCoverage_NamedWindstorm_SubjectToProvisionsNoIndicator_A'),
  namedStormNa:         bool('CommercialPropertyCoverage_NamedWindstorm_SubjectToProvisionsNotApplicableIndicator_A'),
  namedStormLimit:      str('CommercialPropertyCoverage_NamedWindstorm_LimitAmount_A'),
  namedStormDed:        str('CommercialPropertyCoverage_NamedWindstorm_DeductibleAmount_A'),

  waiverSubrogYes:      bool('CommercialProperty_SubrogationWaiver_YesIndicator_A'),
  waiverSubrogNo:       bool('CommercialProperty_SubrogationWaiver_NoIndicator_A'),
  waiverSubrogNa:       bool('CommercialProperty_SubrogationWaiver_NotApplicableIndicator_A'),

  remarks:                   str('EvidenceCommercialProperty_A'),
  additionalInterestName:    str('AdditionalInterestNameAddress_A'),
  lenderServicingAgent:      str('LenderServicingAgentNameAddress_A'),
};
